import { render, staticRenderFns } from "./TagHistoryDialog.vue?vue&type=template&id=471460e6"
import script from "./TagHistoryDialog.vue?vue&type=script&lang=js"
export * from "./TagHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports